/**
 * 详见： http://wiki.hellobike.com/pages/viewpage.action?pageId=57034434
 * 新增需要同步更新 wiki
 */
export enum SystemCodeTypeEnum {
  /** 哈啰app iOS端 */
  AppIos = '61',
  AppAndroid = '62',
  /** 哈啰支付宝小程序 */
  Alipay = '65',
  /** 普通浏览器 */
  H5 = '63',
  /** 哈啰 app- 鸿蒙系统 */
  Harmony = '68',
  /** 独立 app ios */
  Zyq01 = 'Zyq01',
  /** 独立 app Android */
  Zyq02 = 'Zyq02',
  /** 哈臻快 app ios */
  Zxh01 = 'Zxh01',
  /** 哈臻快 app Android */
  Zxh02 = 'Zxh02',
  /** 微信小程序 */
  Zyq04 = 'Zyq04',
  /** 记账app ios */
  Zxy01 = 'Zxy01',
  /** 记账app Android */
  Zxy02 = 'Zxy02',
}
